import styled from '@emotion/styled'
import Button from 'react-bootstrap/Button'

const BaseButton = styled(Button)(({
  backgroundcolor,
  hoverbackgroundcolor,
  color = '#FFFFFF',
  fontSize = '1rem',
  borderColor = backgroundcolor,
  marginLeft,
  theme,
}) => {
  const isBrandBg =
    theme.isLightCustomColor &&
    (backgroundcolor === theme.brandColorOrange ||
      backgroundcolor === theme.brandColorLightOrange) &&
    color === '#FFFFFF'
  const safeColor = isBrandBg ? theme.buttonTextColor : color

  return {
    fontFamily: 'PoppinsMedium',
    backgroundColor: backgroundcolor,
    textTransform: 'none',
    color: safeColor,
    marginLeft,
    fontSize,
    borderColor,
    boxShadow: 'none !important',
    '&:hover': {
      backgroundColor: hoverbackgroundcolor,
      borderColor: hoverbackgroundcolor,
      color: safeColor,
    },
    '&:disabled': {
      backgroundColor: hoverbackgroundcolor,
      borderColor: hoverbackgroundcolor,
      color: safeColor,
    },
    '&:focus': {
      backgroundColor: backgroundcolor,
      borderColor: backgroundcolor,
      color: safeColor,
    },
    '&:active': {
      backgroundColor: `${backgroundcolor} !important`,
      borderColor: `${backgroundcolor} !important`,
      color: safeColor,
    },
  }
})

export default BaseButton
